import { useAuthContext } from "./useAuthContext";

interface UseOrganisationResult {
  organisationId: string | null;
  isLoading: boolean;
}

export const useOrganisation = (): UseOrganisationResult => {
  const { state } = useAuthContext();
  
  return {
    organisationId: state.user?.organisation_id || null,
    isLoading: false,
  };
};
